import { palette, rgba } from '@aegislab/design-tokens';
import { brightTokens } from './bright.tokens';

export const buttonTokens = {
  primary: {
    // 흰 라벨용 채움은 양 끝 모두 dark 계열을 쓴다. default는 전경 액센트다.
    background: `linear-gradient(135deg, ${brightTokens.primary.dark}CC 0%, ${brightTokens.primary.dark}E6 100%)`,
    border: `1px solid ${rgba(palette.blue, 0.5)}`,
    color: '#FFFFFF',
    boxShadow: brightTokens.glow.primary,
    hoverGradient: `linear-gradient(135deg, ${brightTokens.primary.dark}D9 0%, ${brightTokens.primary.dark}F2 100%)`,
  },
  secondary: {
    background: 'rgba(40, 50, 80, 0.7)',
    color: brightTokens.primary.light,
    hoverBg: 'rgba(50, 65, 100, 0.85)',
  },
  ghost: {
    hoverBg: rgba(palette.blue, 0.1),
  },
  danger: {
    gradient: 'linear-gradient(135deg, rgba(212, 72, 72, 0.8) 0%, rgba(170, 40, 40, 0.9) 100%)',
    border: 'rgba(212, 100, 100, 0.5)',
    hoverGradient: 'linear-gradient(135deg, rgba(225, 85, 85, 0.9) 0%, rgba(190, 50, 50, 1) 100%)',
    hoverGlowExtra: '0 2px 10px rgba(212, 72, 72, 0.2)',
  },
  success: {
    gradient: 'linear-gradient(135deg, rgba(122, 191, 94, 0.8) 0%, rgba(90, 160, 70, 0.9) 100%)',
    border: 'rgba(122, 210, 110, 0.5)',
    glow: '0 0 10px rgba(122, 191, 94, 0.3), 0 0 20px rgba(122, 191, 94, 0.15)',
    hoverGradient:
      'linear-gradient(135deg, rgba(140, 205, 110, 0.9) 0%, rgba(110, 180, 85, 1) 100%)',
    hoverGlow: '0 0 12px rgba(122, 191, 94, 0.4), 0 0 24px rgba(122, 191, 94, 0.2)',
  },
  spinner: {
    border: 'rgba(255, 255, 255, 0.3)',
  },
} as const;

export type ButtonTokens = typeof buttonTokens;
